import React,{useEffect, useState} from 'react'
import {Modal, ModalBody } from "react-bootstrap"
import {Row, Col,Form,Container,Button} from "react-bootstrap"
import { InputGroup, InputGroupAddon, InputGroupText, Input, ButtonToggle} from 'reactstrap';
import { Paper, TextField, Checkbox, Select, InputLabel, FormControl, Grid } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import illus from "./Profile.png"
import { withStyles } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import Radio from '@material-ui/core/Radio';
import axios from "axios"
import {Link, Redirect} from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { toast,ToastContainer} from "react-toastify"
import EditIcon from '@material-ui/icons/Edit';
// import ReadyToShop from "../ReadyToShop";
import EditGetUserAddress from "../EditReadyToShop";
import { ModalHeader, ModalFooter } from 'reactstrap';
// import ReadyToShop from "../ReadyToShopES";
import "../common.css"
import  "./Profile.css";
import 'react-toastify/dist/ReactToastify.css';
import { base_url } from '../../globalConstants';
import OtpInput from 'react-otp-input';
import { Otp } from 'react-otp-timer';
import { createGlobalStyle } from 'styled-components';
import {FcCheckmark} from "react-icons/fc";


const cancel={
    color:"darkblue",
    paddingRight: "27px",
    paddingLeft: "27px",
    paddingTop: "15px",
    paddingBottom: "17px",
    borderRadius:"25px",
    border:"none",
    float:"right"
  }

  const buttonstyle={
    color:"darkblue",
    backgroundColor:"skyblue",
    paddingRight: "27px",
    paddingLeft: "27px",
    paddingTop: "15px",
    paddingBottom: "17px",
    textAlign: "center",
    textDecoration: "none",
    borderRadius:"25px",
    border: "3px solid",
    float:"right"
  }

const mystyle = {
    color: "white",
    backgroundColor: "#FF7F50",
    fontFamily: "Arial",
    borderRadius:"12px"
  };

export default function Profile() {

  // NEW VARS

  const [userName,setUserName]=useState('')
  const [firstName,setFirstName]=useState('')
  const [lastName,setLastName]=useState('')
  const [userEmail,setUserEmail]=useState('')
  const [userOldEmail,setUserOldEmail]=useState('')
  const [userPhoneNumber,setUserPhoneNumber]=useState('')
  const [cardVerified,setCardVerified]=useState('')
  const [userShippingAddress,setUserShippingAddress]=useState('')
  const [userShippingCity,setUserShippingCity]=useState('')
  const [userShippingState,setUserShippingState]=useState('')
  const [userShippingCountry,setUserShippingCountry]=useState('')
  const [userShippingZipcode,setUserShippingZipcode]=useState('')
  const [countryList,setCountryList]=useState({})
  const [statesList,setStatesList]=useState({})
  const [LaunchEditModal,setLaunchEditModal]=useState(false);
  
  const [isBillingAddress,setIsBillingAddress]=useState([])
  const [billingDetails,setBillingDetails]=useState([])
  const [userBillingAddress,setUserBillingAddress]=useState('')
  const [userBillingCity,setUserBillingCity]=useState('')
  const [userBillingState,setUserBillingState]=useState('')
  const [userBillingCountry,setUserBillingCountry]=useState('')
  const [userBillingZipcode,setUserBillingZipcode]=useState('')

  const [showAboutModal,setShowAboutModal] = useState(false)
  const [showOtpModal,setShowOtpModal] = useState(false)
  const [isNewDetailsVerified,setIsNewDetailsVerified] = useState(false)
  const [isNewEmailVerified,setIsNewEmailVerified] = useState(false)
  const [isNewNumberVerified,setIsNewNumberVerified] = useState(false)
  const [otpModalHeading,setOtpModalHeading] = useState('')
  const [isEditNum,setIsEditNum] = useState(false)

  //--NEW VARS END

  const [State,setState]=useState([]);
  const [PhoneLength,setPhoneLength]=useState('');
  const [Nation,setNation]=useState('')
  const [TeleCode,setTeleCode]=useState('');
  const [errorMessage, setErrorMessage] = useState('')
  const [Verified,setVerified]=useState(false);
  const [OTP,setOTP]=useState('');
  const [numberNotVerified, setNumberNotVerified] = useState('')
  const [isNumberVerified,  setIsNumberVerified] = useState(false)
  const [isEmailVerified,  setIsEmailVerified] = useState(false)
  const [numberVerified, setNumberVerified] = useState('')
  const [redirectToLogin, setRedirectToLogin] = useState(false)



  const handleOTPchange=(event)=>{
    setErrorMessage("")
    setOTP(event);
  }

    const GreenRadio = withStyles({
        root: {
          color: green[400],
          '&$checked': {
            color: green[600],
          },
        },
        checked: {},
      })((props) => <Radio color="default" {...props} />);

      const [selectedValue, setSelectedValue] = React.useState('no');

//countryFetchAPiVariable

      const [CountryDetails,setCountryDetails]=useState([]);

      //fetchinguserdetailVariable
      const [UserDetails,setUserDetails]=useState([]);


      //form shipping variables
      const [Title,setTitle]=useState('');
      const[Name,setName]=useState('');
      const [Address,setAddress]=useState('');
      const [City,setCity]=useState('');
      const [Zipcode,setZipcode]=useState('');
      const[Phone,setPhone]=useState('');
      const [Email,setEmail]=useState('');
      const[Country,setCountry]=useState('');
      const[UserEzzId,setUserEzzId]=useState('');
      const [States,setStates]=useState([]);
      const [ShippingState,setShippingState]=useState('');
      const [ShippingStateId,setShippingStateId]=useState('');
      const [CountryCode,setCountryCode]=useState('');
      const [Address2,setAddress2]=useState('');
      // const [LastName,setLastName]=useState('');
      

      //Billing address variables starts here.

      const [BillingAddress,setBillingAddress]=useState('');
      const [BillingAddress2,setBillingAddress2]=useState('')
      const [BillingZipCode,setBillingZipCode]=useState('');
      const [BillingCity,setBillingCity]=useState('');
      const [BillingPhone,setBillingPhone]=useState('');
      const [BillingStates,setBillingStates]=useState([]);
      const [BillingCountry,setBillingCountry]=useState('');
      const [FixedBillingState,setFixedBillingState]=useState('');

      //variable recieveing from calling api, fetching data; Rec here is recieved

      const [RecFirstName,setRecFirstName]=useState('');
      const [RecLastName,setRecLastName]=useState('');
      const [RecCity,setRecCity]=useState('');
      const [RecCountry,setRecCountry]=useState('');
      const [RecState,setRecState]=useState('');
      const [RecPhone,setRecPhone]=useState('');
      const [RecZipcode,setRecZipcode]=useState('');
      const [RecAddress1,setRecAddress1]=useState('');
      const [RecAddress2,setRecAddress2]=useState('');
      const [RecEmail,setRecEmail]=useState('');



//modal

const [modal, setModal] = useState(false);


  const toggle = () => setModal(!modal);

  //switch

  const [Switchstate,setSwitchState]=useState(false);

//  const toggleSwitch=()=>setSwitchState(!Switchstate);

    const handleModalClick=()=>{
      // e.preventDefault();

      setLaunchEditModal(!LaunchEditModal);

      // console.log('i am here')
    }


    const handleAboutModal = () => {
      // console.log('CountryDetails',CountryDetails)
      // console.log('userShippingCountry',userShippingCountry)
      CountryDetails.map(keys=>{
        if (keys.country_id === userShippingCountry) {
          // console.log('INSIDE CountryDetails.map(');
          setState(keys.states);
          setCountryCode(keys.telecode);
          setPhoneLength(keys.tele_length);
          console.log(`Telecode Is ${keys.telecode}`)
          setNation(keys.country_id);
          console.log(keys.states)
          setTeleCode(keys.telecode);
          console.log(keys.telecode)
        }
      })
      setShowAboutModal(true)
    }


      const fetchcountries=async e=>{
        const {data}=await axios.get(base_url + 'country_state_details/')
        console.log(data)
        setCountryDetails(data);

        var tempCountries = data
        console.log('countries', tempCountries) 
        var country_name_list = {}

        for (var key in data)
          country_name_list[data[key].country_id] = data[key].name

        console.log('COUNTRYNAME', country_name_list);
        
        setCountryList(country_name_list)

    }

    const fetchUserDetails=async e=>{
      console.log(UserEzzId);
      const {data}=await axios.get(base_url + `customers/${localStorage.getItem(`ezzyid`)}/`)
      console.log(data);
      setUserDetails(data);

      setTitle(data.title);

      setUserName(data.name)
      setUserEmail(data.email)
      setUserOldEmail(data.email)
      setUserPhoneNumber(data.phone_number)
      setPhone(data.phone_number)

      setFirstName(data.name.split(' ')[0])
      setLastName(data.name.split(' ')[1])

      if(data.card_authorize == true)
        setCardVerified("Yes")
      else if(!data.card_authorize)
        setCardVerified("No")
      else
        setCardVerified(data.card_authorize.toUpperCase())

      if(data.address)
        setUserShippingAddress(data.address+', '+data.address_2)  
      setUserShippingCity(data.city)  
      setUserShippingState(data.state_name)  
      setUserShippingCountry(data.country)  
      // setUserShippingCountry(countryList[data.country])  
      setUserShippingZipcode(data.zipcode)  
      

      var firstname=data.name;
      var result=firstname.split(' ');

      localStorage.setItem('username',firstname);

      var residence=data.address;
      // var home=residence.split(' ');


      console.log(result);
      setRecFirstName(result[0]);
      // setRecLastName(result[1]);
      setRecEmail(data.email);
      setRecZipcode(data.zipcode);
      setRecPhone(data.phone_number);
      setRecCity(data.city);
      // setRecAddress1(home[0]);
      // setRecAddress2(home[1]);
      setRecCountry(data.country);
      setRecState(data.state_name);
    

    }

    const fetchBillingDetails = async (userEzzId) =>{

      console.log(userEzzId);
      const billingUrl = base_url +  `customer_billing_address/${userEzzId}/`

      // const {data} = await axios.get(billingUrl)
      
      await axios.get(billingUrl)
      .then(res=>{
        console.log('res',res)
        setIsBillingAddress(true)
        setBillingDetails(res.data)
        setUserBillingAddress(res.data.address_line_1 + ', ' + res.data.address_line_2)
        setUserBillingCountry(res.data.country)
        // setUserBillingCountry(countryList[data.country])
        setUserBillingState(res.data.state_name)
        setUserBillingCity(res.data.city)
        setUserBillingZipcode(res.data.zipcode)
      }).catch(err=>{
        setIsBillingAddress(false)
        setBillingDetails({})
        console.log('err',err)
      })

      // console.log('billingData',data);

      // if(data){
      //   setBillingDetails(data)
      //   setUserBillingAddress(data.address_line_1+', '+data.address_line_2)
      //   setUserBillingCountry(data.country)
      //   // setUserBillingCountry(countryList[data.country])
      //   setUserBillingState(data.state_name)
      //   setUserBillingCity(data.city)
      //   setUserBillingZipcode(data.zipcode)
      // }

    }    

    const toggleSwitch =(event)=>{
      if(event.target.value=== false){
        setSwitchState(true);
      }else if(event.target.value===true){
        setSwitchState(false);
      }

      console.log(event.target.value);
      console.log(RecAddress1)
      if(Switchstate=== true){
        console.log(Switchstate)
        setBillingAddress(RecAddress1);
        setBillingCity(RecCity);
        setBillingPhone(RecPhone);
        setBillingZipCode(RecZipcode);
        setBillingCountry(RecCountry)
        setFixedBillingState(RecState);
        setBillingAddress2(RecAddress2);

      }else if(Switchstate===false){
        console.log(Switchstate)
        setBillingAddress('');
        setBillingCity('');
        setBillingPhone('');
        setBillingZipCode('');
        setBillingCountry('');
        setFixedBillingState('');
        setBillingAddress2('');
      }
    }

  
  const handleChangeTitle=(event)=>{
      setTitle(event.target.value)
  }
  const handleChangeName=(event)=>{
    setName(event.target.value)
    console.log(event.target.value);
  }
 
  const handleChangeZipcode=(event)=>{
    setZipcode(event.target.value)
  }
  const handleChangeAddress=(event)=>{
    setAddress(event.target.value)
  }

  const handleChangeAddress2=(event)=>{
    setAddress2(event.target.value);
  }
  
  const handleLastNameChange=(event)=>{
    setLastName(event.target.value);
  }

  const handleChangeCity=(event)=>{
    setCity(event.target.value);
  }
  const handleChangeCountry=(event)=>{
    setCountry(event.target.value)

    CountryDetails.map(key=>{
      if(key.name===event.target.value){
        setCountryCode(key.country_id);
        setStates(key.states); 
      }
    })
  }
  const handleChangePhone=(event)=>{
    setPhone(event.target.value)
  }
  const handleChangeEmail=(event)=>{
    setEmail(event.target.value)
  }

  const handleChangeState=(event)=>{

    if(selectedValue==='yes'){
      setShippingState(event.target.value);
    
    States.map(key=>{
      if(key.state_name===event.target.value){
        setShippingStateId(key.state_id);
        
        setFixedBillingState(key.state_name);
      }
    })
    }else if(selectedValue==='no'){
      setShippingState(event.target.value);
    
      States.map(key=>{
        if(key.state_name===event.target.value){
          setShippingStateId(key.state_id);
          
          
        }
      })

    }



    
  }

  const handleChangeBillingAddress=(event)=>{
    if(selectedValue==='no'){
      setBillingAddress(event.target.value);
    }
  }

  const handleChangeBillingCity=(event)=>{
    if(selectedValue==='no'){
      setBillingCity(event.target.value);
    }
  }

  const handleChangeBillingPhone=(event)=>{
    if(selectedValue==='no'){
      setBillingPhone(event.target.value);
    }
  }

  const handleChangeBillingZipCode=(event)=>{
    if(selectedValue==='no'){
      setBillingZipCode(event.target.value);
    }
  }

  const handleChangeBillingCountry=(event)=>{
    if(selectedValue==='no'){
      setBillingCountry(event.target.value);
      CountryDetails.map(key=>{
        if(key.name===event.target.value){
          setBillingStates(key.states)
        }
      })  
    }
    
  { /* else if(selectedValue==='yes'){
      CountryDetails.map(key=>{
        if(key.name===event.target.value){
          setBillingStates(key.states);
        }
      })
    }
  */}

  }

  const handleChangeBillingState=(event)=>{
    if(selectedValue==='no'){
      setFixedBillingState(event.target.value);
    }
  }

  const handleChangeBillingAddress2=(event)=>{
    if(selectedValue==='no'){
      setBillingAddress2(event.target.value);
    }
  }



  const handleEditDetails = async e => {
    e.preventDefault();

    setIsNumberVerified(false); 
    setIsEmailVerified(false)

    let token = localStorage.getItem("token")
    console.log('TOKEN',token)
    let header = {
      'Content-Type': 'application/json',
      'AUTHORIZATION': token,
    }
    // var config = {
    //   headers: { 'Content-Type': 'multipart/form-data', 'Authorization': token },
    // };
    
    let editAboutFormData = {}

    // if(!isNewDetailsVerified)
    //   return

    if(isNewEmailVerified && isNewNumberVerified){
      editAboutFormData = {
        name: firstName + ' ' + lastName,
        // email:Email,
        email: userEmail,
        phone_number: Phone
      }
      console.log(editAboutFormData);
    }
    else if(isNewEmailVerified){
      editAboutFormData = {
        name: firstName + ' ' + lastName,
        // email:Email
        email: userEmail
      }
      console.log(editAboutFormData);
    }
    else if(isNewNumberVerified){
      editAboutFormData = {
        name: firstName + ' ' + lastName,
        phone_number: Phone
      }
      console.log(editAboutFormData);
    }
    else{
      editAboutFormData = {
        name: firstName + ' ' + lastName
      }
    }


    if(isNewEmailVerified){
      await axios({
        method: 'POST',
        url: base_url + `update_credentials`,
        data: {'new_email': userEmail},
        headers: header
      }).then((response)=>{
        console.log('emailSuccess',response);
        axios({
          method: 'PATCH',
          url: base_url + `customers/${localStorage.getItem('ezzyid')}/`,
          data: editAboutFormData,
          headers: {'Content-Type': 'application/json' }
          })
          .then(function (response) {
              //handle success
              console.log(response);
              toast.success('Profile Updated Successfully '); 
              setShowAboutModal(false)
              setIsNewEmailVerified(false)
              setIsNewNumberVerified(false)
              setErrorMessage('')
              localStorage.removeItem("token");
              localStorage.removeItem("ezzname");
              localStorage.removeItem("ezzyid");
              localStorage.removeItem("username")
              localStorage.removeItem("validated")
              localStorage.setItem('logged', 'false');
              // fetchUserDetails()    
              // setTimeout(() => {
              //   toggle();
              //   fetchUserDetails();
              // }, 2000);           
              setRedirectToLogin(true)
          })
          .catch(function (response) {
              //handle error
              console.log(response);
              setErrorMessage('Error Updating')
              toast.warn('Some Error! Please try again');
          });

      }).catch((err)=>{
        console.log('emailErr',err.response);
        toast.warn('Profile Update Fail'); 
        setShowAboutModal(false)
        fetchUserDetails()
      })
    }else{
      await axios({
        method: 'PATCH',
        url: base_url + `customers/${localStorage.getItem('ezzyid')}/`,
        data: editAboutFormData,
        headers: {'Content-Type': 'application/json' }
        })
        .then(function (response) {
            //handle success
            console.log(response);
            toast.success('Profile Updated Successfully '); 
            setShowAboutModal(false)
            setIsNewEmailVerified(false)
            setIsNewNumberVerified(false)
            setErrorMessage('')
            localStorage.removeItem("token");
            localStorage.removeItem("ezzname");
            localStorage.removeItem("ezzyid");
            localStorage.removeItem("username")
            localStorage.removeItem("validated")
            localStorage.setItem('logged', 'false');
            // fetchUserDetails()    
            if(isNewNumberVerified){
              setRedirectToLogin(true)
            }


            // setTimeout(() => {
            //   toggle();
            //   fetchUserDetails();
            // }, 2000);           
        })
        .catch(function (response) {
            //handle error
            console.log(response);
            setErrorMessage('Error Updating')
            toast.warn('Some Error! Please try again');
        });
    }


  }
  
  const handleEditFirstName = e => {
    setFirstName(e.target.value)
    console.log(e.target.value);
  }
  
  const handleEditLastName = e => {
    setLastName(e.target.value)
    console.log(e.target.value);
  }
  
  const handleEditEmail = e => {
    setErrorMessage('')
    // setUserEmail(e.target.value)
    setUserEmail(e.target.value)
    console.log(e.target.value);
  }
  
  const handleEditPhoneNumber = e => {
    setErrorMessage('')
    // setUserPhoneNumber(e.target.value)
    setPhone(e.target.value)
    // console.log(e.target.value);
  }
  


  const handleSubmit= async e =>{
    e.preventDefault();
  
  const formData={
    title: Title,
    name:Name + ' ' + lastName ,
    address:Address + ' '+Address2 ,
    city:City,
    zipcode:Zipcode,
    phone_number: Phone,
    email:Email,
    country: CountryCode,
    state: ShippingStateId,
    
    
  }
  console.log(UserEzzId)

    console.log(formData);
  await axios({
    method: 'put',
    url: base_url + `customers/${localStorage.getItem('ezzyid')}/`,
    data:formData,
    headers: {'Content-Type': 'application/json' }
    })
    .then(function (response) {
        //handle success
        console.log(response);
       
        setTimeout(() => {
          toggle();
          fetchUserDetails();
          toast.success('Profile successfully updated'); 

        }, 2000);
        

    })
    .catch(function (response) {
        //handle error
        console.log(response);
        toast.warn('Some Error! Please try again');
    });
  }

    //RESEND OTP START

    let style = {
      otpTimer: {
        margin: '10px',
        color: 'blue',
      },
      resendBtn: {
        // backgroundColor: '#5cb85c',
        // border: '1 px solid #ccc'
        // color: 'white',
        color: '#ff5500',
        border: '1px solid #ff5500',
        backgroundColor: 'white',
        borderRadius: '5px',
        padding: '5px 15px',
  
        "&:hover":{
          color: 'white',
          backgroundColor: '#ff5500',
        },
        "&:focus":{
          outline: '5px solid #ff5500'
        }
      }
    }

  const resendEventEmail = async () => {
    const resendOtpEmailData = new FormData()

    resendOtpEmailData.append('email', userOldEmail)
    resendOtpEmailData.append('new_email',userEmail)

    axios({
      method: 'POST',
      url: base_url + 'update_email',
      data: resendOtpEmailData,
      headers: { 'Content-Type': 'application/json' }
    }).then((response)=>{
      console.log(response);
      console.log('OTP on email sent');
      console.log('resend done')
    }).catch((err)=>{
      console.log(err);
      console.log('OTP on email sending failure');
      console.log('resend failure')
    })
  }


  const resendEvent = async () => {

    const ResendotpData = new FormData();
    ResendotpData.append('MobileNumber', Phone);
    ResendotpData.append('tele', TeleCode);
    ResendotpData.append('type', "verify");
    ResendotpData.append('email', Email);

    axios(
      {
        method: 'post',
        url: base_url+'verify_number/',
        data: ResendotpData,
        headers: { 'Content-Type': 'application/json' }
      }
    )
      .then(function (response) {
        console.log(response);
        console.log('OTP sent');
        console.log('resend done')
      })
      .catch(function (response) {
        console.log(response);
        console.log('OTP sending failure');
        console.log('resend failure')

      })
  }

  useEffect(()=>{
    setUserEzzId(localStorage.getItem('ezzyid'));
    console.log(UserEzzId)
    fetchUserDetails();
    fetchcountries();
    fetchBillingDetails(localStorage.getItem('ezzyid'));
  },[])
    return (
      <div >
      {localStorage.getItem('logged') ==='true' || !redirectToLogin ? ' ': <Redirect to="/"/>}
      <Container>

        <Row>
          <Col lg={{ span: 6 }}>
			<br/><br/>
            <h2 className="general-heading">User Profile</h2>
          </Col>
          <Col lg={{ span: 6 }}>
            
          </Col>
        </Row>

        

        <Row>
            <Col lg={{ span: 12 }}>
              <Row>
                <Col className="justify-content-md-center" lg={{ span: 4 }}>
                  <h4>About</h4><br/>
                  <Row>
                    {/* <Col lg={{ span: 3 }}>
                      <p style={{ fontSize: 'larger' }} >NAME</p>
                    </Col> */}
                    <Col lg={{ span: 10 }}>
                      <TextField id="userName" label="Name" variant="outlined" className='textField'  fullWidth disabled
                          value={userName} type="text" />
                    </Col>                    
                  </Row><br/>
                  <Row>
                    {/* <Col className="justify-content-md-center" lg={{ span: 3 }}>
                      <p style={{ fontSize: 'larger' }} >Email</p>                      
                    </Col> */}
                    <Col lg={{ span: 10 }}>
                      <TextField id="userEmail" label="Email Id" variant="outlined" className='textField' fullWidth disabled
                          value={userEmail} type="email" />
                    </Col>                    
                  </Row><br/>
                  <Row>
                    {/* <Col className="justify-content-md-center" lg={{ span: 3 }}>
                      <p style={{ fontSize: 'larger' }} >Phone Number</p>                      
                    </Col> */}
                    <Col lg={{ span: 10 }}>
                    <TextField id="contactNumber" label="Phone Number" variant="outlined" className='textField' fullWidth disabled
                          value={userPhoneNumber} type="number" />
                    </Col>                    
                  </Row><br/>
                  <Row>
                    {/* <Col lg={{ span: 3 }}>
                      <p style={{ fontSize: 'larger' }} >Card Verified</p>                      
                    </Col> */}
                    <Col lg={{ span: 10 }}>
                    <TextField id="cardVerified" label="Card Verified" variant="outlined" className='textField' fullWidth disabled
                          value={cardVerified} type="text" />
                    </Col>                    
                  </Row><br/>
                  {/* <Row>
                    <Col lg={{ span: 3 }}>
                      <p style={{ fontSize: 'larger' }} >Date Created</p>                      
                    </Col>
                    <Col lg={{ span: 10 }}>
                    <TextField id="dateCreated" label="Created" variant="outlined" className='textField' fullWidth disabled
                          value="NO" type="number" />
                    </Col>                    
                  </Row><br/> */}
                  <Row>
                    <Col lg={{ span: 5 }}>
                      <Button id="editAboutBtn" size='medium' className="customButton1" onClick={handleAboutModal}  >
                        EDIT ABOUT
                      </Button><br />
                    </Col>
                    <Col lg={{ span: 5 }} >
                      <Button id="editAddressBtn" size='medium' className="customButton2" onClick={handleModalClick} >
                        EDIT ADDRESS
                      </Button><br />
                    </Col>
                  </Row>
                </Col>
                <Col lg={{ span: 4 }}>
                  <h4>Shipping Address</h4><br/>
                  <Row>
                    {/* <Col className="justify-content-md-center" lg={{ span: 3 }}>
                      <p style={{ fontSize: 'larger' }} >Address</p>                      
                    </Col> */}
                    <Col lg={{ span: 11 }}>
                    <TextField id="userShippingAddress" label="Address" variant="outlined" className='textField' fullWidth disabled
                          value={userShippingAddress}  type="text" />
                    </Col>                    
                  </Row><br/>
                  <Row>
                    {/* <Col lg={{ span: 3 }}>
                      <p style={{ fontSize: 'larger' }} >City</p>                      
                    </Col> */}
                    <Col lg={{ span: 11  }}>
                      <TextField id="userShippingCity" label="City" variant="outlined" className='textField' fullWidth disabled
                            value={userShippingCity} type="text" />
                    </Col>                    
                  </Row><br/>
                  <Row>
                    {/* <Col className="justify-content-md-center" lg={{ span: 3 }}>
                      <p style={{ fontSize: 'larger' }} >State</p>                      
                    </Col> */}
                    <Col lg={{ span: 11  }}>
                    <TextField id="userShippingState" label="State" variant="outlined" className='textField' fullWidth disabled
                          value={userShippingState} type="text" />
                    </Col>                    
                  </Row><br/>
                  <Row>
                    {/* <Col className="justify-content-md-center" lg={{ span: 3 }}>
                      <p style={{ fontSize: 'larger' }} >Country</p>                      
                    </Col> */}
                    <Col lg={{ span: 11  }}>
                    <TextField id="userShippingCountry" label="Country" variant="outlined" className='textField' fullWidth disabled
                          value={userShippingCountry} type="text" />
                    </Col>                    
                  </Row><br/>
                  <Row>
                    {/* <Col className="justify-content-md-center" lg={{ span: 3 }}>
                      <p style={{ fontSize: 'larger' }} >Zipcode</p>                      
                    </Col> */}
                    <Col lg={{ span: 11   }}>
                    <TextField id="userShippingZipCode" label="Zipcode" variant="outlined" className='textField' fullWidth disabled
                          value={userShippingZipcode} type="text" />
                    </Col>                    
                  </Row><br/>                 
                </Col>
                <Col className="justify-content-md-center" lg={{ span: 4 }}>
                  <h4>Billing Address</h4><br/>
                  <Row>
                    {/* <Col className="justify-content-md-center" lg={{ span: 3 }}>
                      <p style={{ fontSize: 'larger' }} >Address</p>                      
                    </Col> */}
                    <Col lg={{ span: 11 }}>
                      <TextField id="userBillingAddress" label="Address" variant="outlined" className='textField' fullWidth disabled
                          value={userBillingAddress}  type="text" />
                    </Col>                    
                  </Row><br/>
                  <Row>
                    {/* <Col lg={{ span: 3 }}>
                      <p style={{ fontSize: 'larger' }} >City</p>                      
                    </Col> */}
                    <Col lg={{ span: 11 }}>
                    <TextField id="userBillingCity" label="City" variant="outlined" className='textField' fullWidth disabled
                          value={userBillingCity} type="text" />
                    </Col>                    
                  </Row><br/>
                  <Row>
                    {/* <Col lg={{ span: 3 }}>
                      <p style={{ fontSize: 'larger' }} >State</p>                      
                    </Col> */}
                    <Col lg={{ span: 11 }}>
                    <TextField id="userBillingState" label="State" variant="outlined" className='textField' fullWidth disabled
                          value={userBillingState} type="text" />
                    </Col>                    
                  </Row><br/>
                  <Row>
                    {/* <Col  lg={{ span: 3 }}>
                      <p style={{ fontSize: 'larger' }} >Country</p>                      
                    </Col> */}
                    <Col  lg={{ span: 11 }}>
                    <TextField id="userBillingCountry" label="Country" variant="outlined" className='textField' fullWidth disabled
                          value={userBillingCountry} type="text" />
                    </Col>                    
                  </Row><br/>
                  <Row>
                    {/* <Col  lg={{ span: 3 }}>
                      <p style={{ fontSize: 'larger' }} >Zipcode</p>                      
                    </Col> */}
                    <Col  lg={{ span: 11 }}>
                    <TextField id="userBillingZipCode" label="Zipcode" variant="outlined" className='textField' fullWidth disabled
                          value={userBillingZipcode} type="text" />
                    </Col>                    
                  </Row><br/>

                </Col>
              </Row>
            </Col>
        </Row>

        <Modal show={showAboutModal}>
        <Modal.Body>

          <CloseIcon onClick={()=>setShowAboutModal(false)} style={{ display: 'flex', float: 'right', cursor: 'pointer', margin: '3px 5px 0 0' }}  /><br/>

          <Container>
            <Row>

              <Col lg={{ span: 12 }}>

                <h4 className='editAboutModal' >Update Details</h4><br/>
               
                <Form onSubmit={handleEditDetails}>
                  <Row>
                    <Col>
                      <Row >
                        <Col className="justify-content-md-center"  >
                          <TextField id="first_name" label="First Name" variant="filled" value={firstName} 
                            onChange={handleEditFirstName} className='textField' fullWidth />
                        </Col>
                        <Col className="justify-content-md-center"  >
                          <TextField id="last_name" label="Last Name" variant="filled" value={lastName} 
                            onChange={handleEditLastName} className='textField' fullWidth />
                        </Col>
                    </Row><br/>
                    <Row >
                      <Col className="justify-content-md-center" lg={{ span: 10 }} >
                        <TextField id="email_id" label="Email" variant="filled" className='textField' fullWidth
                          value={userEmail} onChange={handleEditEmail} type="email" />
                      </Col>
                      <Col className="justify-content-md-center" lg={{ span: 2 }}  style={{ textAlign: 'center' }}>
                        {
                          isEmailVerified
                          ?
                            <h2><FcCheckmark /></h2>
                          :                        
                              <Button variant="Link" id="validateOTPemail" className=" loginlink "

                                onClick={(e) => {
                                  e.preventDefault();

                                  setOtpModalHeading('Email Verification')
                                  setIsEditNum(false)
                            
                                  const emailFormData = new FormData()
                                  emailFormData.append('email', userOldEmail)
                                  emailFormData.append('new_email', userEmail)

                                  // const phonedata = new FormData();
                                  // phonedata.append('MobileNumber', Phone);
                                  // phonedata.append('MobileNumber', Phone);
                                  // phonedata.append('tele', TeleCode);
                                  // phonedata.append('type', "verify");
                                  // phonedata.append('email', Email);

                                  axios({
                                    method: 'get',
                                    // url: base_url + `customers/?ezz_id=&ezz_id__icontains=&email__iexact=${userEmail}&phone_number=`,
                                    url: base_url + `customers/?ezz_id=&ezz_id__icontains=&email__icontains=${userEmail}&phone_number=&zipcode__icontains=`,

                                  }).then(function (response) {
                                    console.log(response)                                    
                                    // toast.success('no. already exists');
                                    if (response.data.results.length === 0) {
                                      axios({
                                        method: 'post',
                                        url: base_url + 'update_email',
                                        data: emailFormData,
                                        headers: { 'Content-Type': 'application/json' }
                                      }).then(function (response) {

                                        console.log(response);
                                        setShowOtpModal(!showOtpModal);


                                      }).catch(function (response) {
                                        console.log('OTP failure');
                                        console.log(response);
                                      })
                                    } else {
                                      setErrorMessage('Email already exists')
                                      // setErrorNotVerified('Number already exists')
                                      // toast.success('no. already exists.')
                                    }
                                  }).catch(function (response) {
                                    console.error(response);

                                  })


                                }}
                        
                        >
                          Verify                        
                        </Button>  
                        }     
                      </Col>
                    </Row><br/>
                    <Row >
                      <Col className="justify-content-md-center" lg={{ span: 10 }} >
                        <TextField id="phoneNumber" label="Mobile Number" type='number' className='textField' variant="filled" 
                          value={Phone}  onChange={handleEditPhoneNumber} fullWidth />
                        {
                          // Phone.length > 0 && Phone.length < PhoneLength
                          Phone.length > 0 && Phone.length < PhoneLength
                            ? <p style={{ color: 'red', fontSize: 'small', textAlign: 'center', marginBottom: 0 }}>*Please enter at least {PhoneLength} digit number</p>
                            : ' '
                        }
                      </Col>
                      <Col className="justify-content-md-center" lg={{ span: 2 }} style={{ textAlign: 'center' }} >
                        {

                          isNumberVerified
                          ?
                            <h2><FcCheckmark /></h2>
                          :
                          <Button variant="Link" id="validateOTP" className=" loginlink " 

                          // onClick={() => setShowOtpModal(!showOtpModal)}

                          onClick={(e) => {
                            e.preventDefault();

                            setOtpModalHeading('Phone Number Verification')
                            setIsEditNum(true)

                            console.log(TeleCode + Phone)


                            const phonedata = new FormData();
                            // phonedata.append('MobileNumber', Phone);
                            phonedata.append('MobileNumber', Phone);
                            phonedata.append('tele', TeleCode);
                            phonedata.append('type', "verify");
                            phonedata.append('email', Email);

                            axios({
                              method: 'get',
                              url: base_url+`customers/?ezz_id=&ezz_id__icontains=&email__iexact=&phone_number=${Phone}`,

                            }).then(function (response) {
                              console.log(response)
                              // toast.success('no. already exists');
                              if (response.data.results.length === 0) {
                                axios({
                                  method: 'post',
                                  url: base_url+'verify_number/',
                                  data: phonedata,
                                  headers: { 'Content-Type': 'application/json' }
                                }).then(function (response) {

                                  console.log(response);
                                  setShowOtpModal(!showOtpModal);


                                }).catch(function (response) {
                                  console.log('OTP failure');
                                  console.log(response);
                                })
                              } else {
                                setErrorMessage('Number already exists')
                                // setErrorNotVerified('Number already exists')
                                // toast.success('no. already exists.')
                              }
                            }).catch(function (response) {
                              console.error(response);

                            })


                          }} 
                      >
                          Verify
                      </Button>

                        }
 
                      </Col>
                    </Row><br/>
                    <Row>
                      <Col style={{ textAlign: 'center' }}>
                        {
                          errorMessage
                            ? <span className='errorText'>{errorMessage}<br /></span>
                            : ""
                        }
                      </Col>
                    </Row>
                      
                      <Row>
                        <Col>
                            <Button id="getYourUsAddress" size='lg' className="customButton1" type="submit" block >
                              UPDATE
                            </Button>
                        </Col>
                        <Col>
                          <Button id="doThisLater" className="customButton2" variant="outline-primary" size='lg' block
                            onClick={() => { setShowAboutModal(false); setIsNumberVerified(false); setIsEmailVerified(false); setErrorMessage('') } } >
                              CANCEL
                      </Button><br />
                      </Col>
                    </Row><br/>
                    </Col>
                    </Row>
                  </Form>    
              </Col>
             </Row> 
          </Container>
        </Modal.Body>
       </Modal> 

       <Modal style={{ height: '80%' }} show={showOtpModal}>
         
          <ModalHeader>{otpModalHeading}</ModalHeader>
            <ModalBody>
                          
              {
                isEditNum
                ?
                  <><h6>Please enter Code sent on your Contact Number: <br/> +{CountryCode}-{Phone}</h6><br/><br /></>
                :
                  <><h6>Please enter Code sent on your Email: <br/> {userEmail}</h6><br/><br /></>
              }
                <Row>
                
                <Col xs={6} md lg={6}>
                  
                  <OtpInput
                    inputStyle={style={"outline":"none","border":"none",'width':"50px","height":"50px","borderBottom":"3px solid black","fontSize":"20px"}}
                    minutes={1.99}      // Minutes ( Pass the no of minutes that you want count )
                    // resendEvent={resendEvent} //  Resend button event you can pass your function name here
                    
                    resendEvent={isEditNum? resendEvent : resendEventEmail} //  Resend button event you can pass your function name here

                    numInputs={4}
                    separator={<span>-</span>}
                    onChange={(event)=>{handleOTPchange(event)}}
                    value = {OTP}
                  />
                  {
                    numberNotVerified == ''
                      ? ""
                      : <span style={{ color: "red", textAlign: "center", fontWeight: "600", fontSize: 'small' }}>{numberNotVerified}</span>
                  }
                </Col>
               
                <Col xs={6} md lg={5} style={{ textAlign: 'center' }}>
                        <Otp
                          style={style}
                          minutes={1.99}      // Minutes ( Pass the no of minutes that you want count )

                          // resendEvent={resendEvent} //  Resend button event you can pass your function name here
                          resendEvent={isEditNum? resendEvent : resendEventEmail} //  Resend button event you can pass your function name here
                        />
                      </Col>

              </Row><br/>
              
              <ModalFooter>
                  <Button className="customButton1" 
                  onClick={(e) => {
                    e.preventDefault();

                    
                      if(isEditNum){
                        console.log(TeleCode);
                        axios.get(base_url+`verify_number/?MobileNumber=${Phone}&otp=${OTP}&type=verify`)
                          .then(function (response) {
                            console.log("OTP verification success")
                            console.log(response);
    
                            // setNestedModal(!nestedModal);
                            // setCloseAll(false);
                            setVerified(true);
                            setNumberVerified('Number Verified Successfully')
                            setIsNumberVerified(true)
                            setIsNewDetailsVerified(true)
                            setIsNewNumberVerified(true)
                            // setCloseAll(true);
                            // setNestedModal(!nestedModal);
                            // setCloseAll(true);
                            // toggleAll()
                            // toggle()
                            setShowOtpModal(false)
                          })
                          .catch(function (response) {
    
                            console.log(response)
                            console.log(response.Status)         
                            
                            setNumberNotVerified(`Incorrect code!! Please enter again`)
                            // if (response.status == 403) {
                            //   setNumberNotVerified('Incorrect code!! Please enter again')
                            //   // toast.warn('Wrong OTP!! Please enter again')
                            // } else {
                            //   setNumberNotVerified('Please Try Again')
                            //   // toast.warn('Please Try Again');
                            // }
                          })
                      }else{
                        axios.get(base_url+`update_email?old_email=${userOldEmail}&otp=${OTP}&new_email=${userEmail}`)
                          .then(function (response) {
                            console.log("OTP verification success")
                            console.log(response);
    
                            // setNestedModal(!nestedModal);
                            // setCloseAll(false);
                            setVerified(true);
                            setNumberVerified('Email Verified Successfully')
                            setIsEmailVerified(true)
                            setIsNewDetailsVerified(true)
                            setIsNewEmailVerified(true)
                            // setCloseAll(true);
                            // setNestedModal(!nestedModal);
                            // setCloseAll(true);
                            // toggleAll()
                            // toggle()
                            setShowOtpModal(false)
                          })
                          .catch(function (response) {
    
                            console.log(response)
                            console.log(response.Status)         
                            
                            setNumberNotVerified(`Incorrect code!! Please enter again`)
                            
                            // if (response.status == 403) {
                            //   setNumberNotVerified('Incorrect code!! Please enter again')
                            //   // toast.warn('Wrong OTP!! Please enter again')
                            // } else {
                            //   setNumberNotVerified('Please Try Again')
                            //   // toast.warn('Please Try Again');
                            // }
                          })
                      }



                  }}
                  // onClick={toggle}
                  >
                    SUBMIT
                </Button>{' '}
                  <Button id="closeOtpModal2" className="customButton2" 
                    onClick={()=>{setShowOtpModal(false); setErrorMessage(''); setIsNewEmailVerified(false); setIsNewNumberVerified(false)  }}  >
                      CLOSE
                  </Button>                      
              </ModalFooter>

              {/* <Modal isOpen={nestedModal} toggle={toggleNested} onClosed={closeAll ? toggle : undefined}>

                <h3 style={{ color: "#FF4500", fontSize: "4opx" }}>Phone Number Verification done successfully!!</h3>
                <ModalFooter>
                  <Button color="primary" onClick={toggleAll}>Done</Button>{' '}

                </ModalFooter>
              </Modal> */}
            </ModalBody>

          </Modal> 

      </Container>

      {/* {
        LaunchEditModal 
        ? <ReadyToShop showAddressModal={LaunchEditModal} isEditOption = {true} userData={UserDetails} 
            billingData={billingDetails} isBillingData = {isBillingAddress} /> 
        : ' '
      }   */}
      {
        LaunchEditModal 
        ? <EditGetUserAddress showAddressModal={LaunchEditModal}  /> 
        : ' '
      }  
        
        </div>
    )
}
